// The account page saves every row it shows, so each installment carries the editable figures as
// last loaded or saved. The server writes only the figures that differ from this baseline and
// refuses a figure someone else changed in the meantime.
const baselineOf = (row) => ({
  commission: row?.commission ?? null,
  bonus: row?.bonus ?? null,
  referral: row?.referral ?? null,
});

export const withInstallmentBaseline = (row) => ({ ...row, baseline: baselineOf(row) });

// After a successful save the server holds the sent figures, so they become the new baseline. Only
// the baseline moves: edits typed while the save was in flight stay on the row.
export const advanceInstallmentBaselines = (accountDetails, sentAccountDetails) => {
  const sentByUuid = new Map(
    (sentAccountDetails || [])
      .flatMap((entry) => entry?.admissionDetails || [])
      .filter((row) => row?.uuid)
      .map((row) => [row.uuid, baselineOf(row)])
  );
  if (sentByUuid.size === 0) return accountDetails;
  return accountDetails.map((entry) => {
    if (!entry?.admissionDetails?.some((row) => sentByUuid.has(row.uuid))) return entry;
    return {
      ...entry,
      admissionDetails: entry.admissionDetails.map((row) =>
        sentByUuid.has(row.uuid) ? { ...row, baseline: sentByUuid.get(row.uuid) } : row
      ),
    };
  });
};
